<template>
  <div class="row sl-content">
    <div class="col-lg left-main-div-sl">
      <title-sl :title="title" :color="titlecolor" :type="pagetype" />

      <div class="left-main-div-subtitle-sl">{{ $t('sl.tocome') }} {{ $t('sl.hour') }} </div>
  
      <meetup-details :meetups="serviceLinesUpcoming" :isupcoming="isUpComing" :type="pagetype"/>

      <div  class="left-main-div-subtitle-sl">{{ $t('sl.pastmeetup') }}</div>
      <div class="past-metup-div">  
        <!-- <div class="date-title-div"><samp class="icon-date-meetup" @click="getSlPreviousYear">&#60;</samp> &nbsp; {{this.year}} &nbsp; <samp :class="this.year<this.currentYear?'icon-date-meetup':'d-none'" @click="getSlNextYear">&#62;</samp></div> -->
        <!-- <div class="black-separation"></div> -->
        <div class="sl-div-scroll">
          <div class="meetup-detail-container">
            <meetup-details :meetups="serviceLinesYear" :isupcoming="isNotUpComing" :type="pagetype" :all="allNewestServiceLines"/>
          </div>
        </div>
      </div>
      
    </div>

    <div class="col-lg-2 right-main-div-sl">
      <calendar-sl :meetupsCalendar="meetupscalendar"/>

      <div class="right-content-sl search-content">
        <div class="small-title-sl">{{ $t('sl.search.title') }}</div>
        <div class="search-div">
          <input class="search-input" placeholder="" v-model="search" @input="searchServiceLines" v-on:keyup.enter="searchServiceLines"/> <i @click="searchServiceLines" class="el-icon-search search"  ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import VCalendar from 'v-calendar';
  import { mapActions } from "vuex";
  import MeetupDetails from '@/components/ServiceLines/MeetupDetails';
  import TitleSL from '@/components/ServiceLines/TitleSL';
  import CalendarSL from '@/components/ServiceLines/CalendarSL';
  import MeetupPerYear from '@/components/ServiceLines/MeetupPerYear';
  
  Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  });

  export default {
    name: 'sl-content', 
    
    components: {
      'meetup-details' : MeetupDetails,
      'title-sl': TitleSL,
      'calendar-sl': CalendarSL,
      'meetup-per-year': MeetupPerYear
      
    },
    props: {
        pagetype:String,
        pagename:String,
        title:String,
        titlecolor:String,
        meetupscalendar:[]


    },
    data() {
      this.loadServiceLines();
      return {
          lang: Vue.i18n.locale(),
          serviceLinesUpcoming: [],
          serviceLinesYear: [],
          allNewestServiceLines: [],
          search:'',
          year:new Date().getFullYear(),
          currentYear:new Date().getFullYear(),
          isUpComing:true,
          isNotUpComing:false
      };
    },
    computed:{
    },
    methods:{
      ...mapActions(["GetListServiceLines"]),
      async loadServiceLines() {
        this.getUpcoming();
        this.year = new Date().getFullYear();
        //PR-2023
        //this.getYear();
        this.getNewest();
        this.getAllNewest();
        //
      },
      async getNewest(){
        let sLRequest= {
            search: this.search,
            lang: Vue.i18n.locale(),
            type: this.pagetype
          };
        await this.GetListServiceLines(sLRequest);
        this.serviceLinesYear = this.$store.getters.AllServiceLines; 
      },      
      // async getYear(){
      //   let sLRequest= {
      //       search: this.search,
      //       lang: Vue.i18n.locale(),
      //       type: this.pagetype,
      //       filter:'year',
      //       year:this.year
      //     };
      //   await this.GetListServiceLines(sLRequest);
      //   this.serviceLinesYear = this.$store.getters.AllServiceLines; 
      // },
      async getAllNewest() {
        let sLRequest= {
          lang: Vue.i18n.locale(),
          type: this.pagetype
        };
        await this.GetListServiceLines(sLRequest);
        this.allNewestServiceLines = this.$store.getters.AllServiceLines; 
      },      
      async getUpcoming(){
        let sLRequest= {
            search: this.search,
            lang: Vue.i18n.locale(),
            type:this.pagetype,
            filter:'upcoming'
          };
        await this.GetListServiceLines(sLRequest);
        this.serviceLinesUpcoming = this.$store.getters.AllServiceLines; 
      },
      async searchServiceLines(){
        this.getUpcoming();
        //this.getYear();
        this.getNewest();
      },
      // async getSlPreviousYear(){
      //   this.year=this.year-1;
      //   this.getYear();
      // },
      // async getSlNextYear(){
      //   if(this.year<new Date().getFullYear()){
      //     this.year=this.year+1;
      //     this.getYear();
      //   }
      // }
    }
  };
</script>

